function getAppPlatform(): string {
  return 'web';
}

function getAppInfo(): Promise<{ userAgent: string; version: string }> {
  return Promise.resolve({ userAgent: navigator.userAgent, version: '1.0.0' });
}

function getMobileFontSize() {
  return Promise.resolve(null);
}

function setMobileFontSize(_fontSize: number | string) {}

export { getAppInfo, getAppPlatform, getMobileFontSize, setMobileFontSize };
